import { Employee } from "@/v2/types";
import FindAllEmployees from "@/v2/api/employee/FindAll";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";

interface EmployeeFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function EmployeeFilterComboBox({
    value,
    onChange,
    placeholder = "Select employee...",
    disabled = false,
    className,
    label = "Employee",
}: EmployeeFilterComboBoxProps) {
    const handleSelect = (item: Employee | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (employee: Employee) => (
        <div className="flex flex-col">
            <span>{employee.full_name}</span>
            {employee.iqama && (
                <span className="text-xs text-muted-foreground">
                    {employee.iqama}
                </span>
            )}
            {employee.trade && (
                <span className="text-xs text-muted-foreground">
                    Trade : {employee.trade[0]}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<Employee>
            label={label}
            labelAlign="items-start"
            queryKey={["employees"]}
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllEmployees({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(employee: Employee) => employee.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search employees..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
